// src/components/Admin/AdminLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import AdminTabs from "./AdminTabs";
import "../../styles/layout.css";

const AdminLayout = () => {
  return (
    <main className="admin-main">
      <div className="container mt-3 mb-4">
        <AdminTabs />
        <Outlet />
      </div>
    </main>
  );
};

export default AdminLayout;
